/*
 * @Author: tong.kai
 * @Date: 2020/9/22 9:56
 * @FilePath: \xjmediacloud\app\components\util\typeHead\typeHead.js
 * @Description:
 */
'use strict';
angular.module('typeHeadModule', []).directive('typeHead', [
    'editingCenterService',
    function (editingCenterService) {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            templateUrl: './components/util/typeHead/typeHead.html',
            link: function ($scope, ele) {
                init();

                /**
                 * [init description] 初始化
                 * @return  {[type]}  [return description]
                 */
                function init(){
                    $scope.$watch('list.NEWSSOURCES', (newVlue) => {
                        if (!newVlue) {return;}
                        $scope.list.NewDocSourceName = $scope.list.NEWSSOURCES;
                        delete $scope.list.NEWSSOURCES;
                    });
                    $scope.$watch('list.DOCSOURCENAME', (newVlue) => {
                        if (!newVlue) {return;}
                        $scope.list.NewDocSourceName = $scope.list.DOCSOURCENAME;
                        delete $scope.list.DOCSOURCENAME;
                    });
                }

                /**
                 * [getSuggestions description]获取suggestion
                 * @param  {[str]} viewValue [description]输入框内输入值
                 * @return {[type]}           [description]
                 */
                $scope.getSuggestions = function (viewValue) {
                    return editingCenterService.getRecentUsageSources(viewValue);
                };

                /**
                 * [selectResource description] 选择稿源
                 * @param   {[type]}  value  [value description]
                 * @return  {[type]}         [return description]
                 */
                $scope.selectResource = function (value) {
                    $scope.list.NewDocSourceName = value.SRCNAME;
                    const input = ele.find('input');
                    input[0].setSelectionRange(input[0].value.length, input[0].value.length);
                };
            },
        };
    },
]);
